// extracted by mini-css-extract-plugin
module.exports = {"text-grey":"L8pE0ROd33fFhQVwczvN7","product-count-text":"_36m1eeOjYWHJ26hL_AJJxT"};